function fn_comp_contact() {
    var $fn = $(".comp_contact");

    if ($fn.length){
        var $map = $(".part_filter_map");

        function fn_part_filter_map() {
            if ($map.length) {
                $.getScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyDcbN9swRI4aQSgRFZeIrQpAATWwhlTieM")
                    .done(function () {
                        $map.nl_google_map('init');
                        $map.nl_google_map('markers_add');
                    });
            }
        }

        fn_part_filter_map();
    }
}